import { getAjaxModal } from 'lib/ajax-helpers';
import { SHOW_PAGE_MODAL_CLICK } from 'components/analytics/conversions/constants/actions';
import { sendTrackingEvent } from 'components/analytics/conversions/tracking';
import events from 'lib/events';
import { fetchState } from 'lib/state-helpers';
import {
  triggerCustomEvent,
  getWindowWidth,
  injectPrefetchLink,
  isVideoUrl,
} from 'lib/helpers';

export const getContextPositionByHref = (context, href) => (
  Object.keys(context).find((key) => context[key].href === href));

export const sendShowPageModalClick = (event:MouseEvent) => {
  const currentTarget = event.currentTarget as HTMLElement;
  const parentThumb = currentTarget.closest('.ez-resource-thumb') as HTMLElement;
  const licenseType = parentThumb.dataset.pro === 'true' ? 'Pro' : 'Free';

  sendTrackingEvent({
    element: currentTarget,
    data: {
      action: SHOW_PAGE_MODAL_CLICK,
      label: licenseType,
      content_type: `Content-${currentTarget.dataset.contentType}`,
    },
  });
};

export const removeExistingPrefetchLinks = () => {
  const head = document.getElementsByTagName('head')[0];
  const existingPrefetchLinks = head.querySelectorAll('link.modal-show-prefetch');

  existingPrefetchLinks.forEach((link) => {
    head.removeChild(link);
  });
};

export const injectModalPrefetching = () => {
  const contextState = fetchState('resources-nav-context');
  const curPos = parseInt(contextState.currentPosition, 10);

  const prefetchPreviewMedia = () => {
    const prevPreviewsSrcs = JSON.parse(contextState[curPos - 1]?.previewsSrcs || '[]');
    const nextPreviewsSrcs = JSON.parse(contextState[curPos + 1]?.previewsSrcs || '[]');
    const previewsSrcsArray = [...prevPreviewsSrcs, ...nextPreviewsSrcs];

    previewsSrcsArray.forEach((src) => {
      const asAttr = isVideoUrl(src) ? 'video' : 'image';

      injectPrefetchLink({ src, asAttr, linkClass: 'modal-show-prefetch' });
    });
  };

  removeExistingPrefetchLinks();
  prefetchPreviewMedia();
};

export const loadShowPageModal = ({
  event = null,
  url,
  container = null,
  callback = null,
}:{
  event:MouseEvent
  url:string
  container:HTMLElement
  callback:() => void
}) => {
  if (getWindowWidth() > 1000) {
    const currentTarget = event.currentTarget as HTMLElement;

    event.preventDefault();

    sendShowPageModalClick(event);

    triggerCustomEvent(events.show_page.modal.build_resource_navigation_context, {
      targetResourcePath: url,
      targetResourceGroup: container || currentTarget.closest('[data-controller*="resources-grid"]'),
    });

    getAjaxModal(url, () => {
      injectModalPrefetching();

      if (callback) callback();
    });
  }
};
